import { render } from "./GiftDonation.vue?vue&type=template&id=4454fd94&scoped=true"
import script from "./GiftDonation.vue?vue&type=script&lang=js"
export * from "./GiftDonation.vue?vue&type=script&lang=js"

import "./GiftDonation.vue?vue&type=style&index=0&id=4454fd94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4454fd94"]])

export default __exports__